const expensesType  = [

    { name : 'transport', content: 'Transport' },
    { name : 'frais', content: 'Frais' },
    { name : 'salaire', content: 'Salaire' },
    { name : 'autres', content: 'Autres type de dépense' },

  ];


const debtsType = [

    { name : 'emprunt', content: 'Emprunt' },
    { name : 'avance', content: 'Avance' },
    { name : 'credit', content: 'Crédit' },
    { name : 'autres', content: 'Autres type de créance' },

  ];


export {
   debtsType, 
   expensesType 
} ;